import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE_OTHER_EQUIPMENT',
  CREATE: 'CREATE_ZONE_OTHER_EQUIPMENT',
  EDIT: 'EDIT_ZONE_OTHER_EQUIPMENT',
  DELETE: 'DELETE_ZONE_OTHER_EQUIPMENT',
};

export const searchOtherEquipmentInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  const zoneParams = zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_OTHER_EQUIPMENT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listOtherEquipmentInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  return {
    type: ACTION.LIST,
    payload: searchOtherEquipmentInZone(pageSize, page, sorted, filtered, isPublic, zoneId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addOtherEquipmentToZone = (equipmentId, zoneId, quantity) => {
  const formData = new FormData();
  formData.set('equipment_id', equipmentId);
  formData.set('zone_id', zoneId);
  formData.set('quantity', quantity);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_OTHER_EQUIPMENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editOtherEquipmentInZone = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE_OTHER_EQUIPMENT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeOtherEquipmentFromZone = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ZONE_OTHER_EQUIPMENT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_other_equipment_actions.js